<template>
  <div
    v-if="loaded"
    :class="{[size]: size}"
    class="controls"
  >
    <MetaInfo v-if="size !== 'size-mini'" />

    <PlayPause />

    <div :class="{'scrubber-timer': true, disabled: !epi || !epi.enclosure_url}">
      <Scrubber />

      <ShareSubscribe />

      <div class="left">
        <Speed />
      </div>

      <div class="middle">
        <Rewind v-if="epi" />

        <!-- Only visible on smaller widths -->
        <PlayPause />

        <Forward v-if="epi" />
      </div>

      <div class="right">
        <!-- Changes position on smaller widths -->
        <ShareSubscribe />

        <!-- Only visible on smaller widths -->
        <Artwork />
      </div>
    </div>
  </div>
</template>

<script>
// import Controls from './Controls'
import Artwork from './Artwork'
import Forward from './Forward'
import Rewind from './Rewind'
import Speed from './Speed'
import MetaInfo from './MetaInfo'
import PlayPause from './PlayPause'
import Scrubber from './Scrubber'
import ShareSubscribe from './ShareSubscribe'
import Store from '../store'

export default {
  components: {
    Artwork,
    Forward,
    Rewind,
    Speed,
    MetaInfo,
    PlayPause,
    Scrubber,
    ShareSubscribe
  },
  data () {
    return { store: Store }
  },
  computed: {
    epi () { return this.store.state.episode },
    loaded () { return this.store.state.isLoaded },
    size () { return this.store.state.size }
  }

}
</script>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints.scss';

.controls {
  align-items: flex-end;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;

  @media (min-width: $bp_xs) {
    align-items: center;
    padding-top: 12px;
  }
  @media (min-width: $bp_sm) {
    padding-top: 0;
  }

  .play-pause {
    display: none;
    height: 44px;
    width: 44px;

    @media (min-width: $bp_xs) {
      display: flex;
      height: 59px;
      margin-right: 16px;
      width: 58px;
    }
    @media (min-width: $bp_sm) {
      height: 72px;
      margin-top: 0;
      width: 71px;
    }
  }
  .meta-info {
    display: none;
    height: 50%;

    @media (min-width: $bp_sm) {
      display: block;
    }
  }
  &.size-mini {
    .scrubber-timer {
      > .controls-subscribe {
        display: none;
      }
    }
  }
  .scrubber-timer {
    display: flex;
    flex: 1;
    flex-wrap: wrap;

    > .controls-share,
    > .controls-subscribe {
      flex-basis: 100%;
      margin: 10px 0 23px 0;

      @media (min-width: $bp_xs) {
        flex-basis: 50%;
        display: none;
        margin: 0px 0 23px 0;
      }
    }
    &:hover {
      .left,
      .middle,
      .right,
      .controls-forward,
      .controls-rewind {
        opacity: .75;
      }
    }
    &.disabled {
      display: none
    }
    .controls-forward,
    .controls-rewind {
      opacity: .95;

      @media (min-width: $bp_xs) {
        opacity: 0;
        transition: opacity .2s ease-in-out;
        &:focus {
          opacity: .75;
        }
      }
    }
    .left,
    .middle,
    .right {
      opacity: .95;

      @media (min-width: $bp_xs) {
        opacity: .95;
        transition: opacity .2s ease-in-out;
      }
    }
  }
  .left {
    display: flex;
  }
  .middle {
    display: flex;
    flex: 1;
    justify-content: center;
  }
  .right {
    display: flex;

    .controls-speed {
      display: none;
    }
    .controls-share,
    .controls-subscribe:not(.size-mini) {
      display: none;

      @media (min-width: $bp_xs) {
        display: block;
      }
    }
  }
  .artwork {
    height: 44px;
    max-width: 44px;
    width: 100%;
  }
  .artwork,
  .middle button.play-pause {
    display: block;

    @media (min-width: $bp_xs) {
      display: none;
    }
  }
  // MINI PLAYER STYLES
  &.size-mini {
    align-items: flex-start;
    display: flex;
    padding-top: 0;

    > .play-pause {
      margin-top: 0;
    }
    .left,
    .middle,
    .artwork,
    .controls-share {
      display: none;
    }
    .scrubber-timer {
      flex-wrap: nowrap;
      &.disabled {
        display: none
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      opacity: 1;
      padding-left: 8px;

      .controls-share,
      .controls-speed {
        display: flex;
        justify-content: center;
        width: 100%;
      }
    }
  }
}
</style>
